import { Injectable } from '@angular/core';
import { FiltroSqp } from '../../sqpFiltroSuperior/models/filtro-sqp';

@Injectable({
  providedIn: 'root'
})
export class CalendarioRangoService {

  rangoSeleccionado: string = '';
  private filtroFechaEnvioPersistido: FiltroSqp | null = null;

  constructor() { }

  guardarFiltroFechaEnvio(filtro: FiltroSqp): void {
    const desde = filtro.valoresSeleccionados?.valorFechaDesde;
    const hasta = filtro.valoresSeleccionados?.valorFechaHasta;
    this.filtroFechaEnvioPersistido = {
      ...filtro,
      valoresSeleccionados: {
        ...filtro.valoresSeleccionados,
        valorFechaDesde: desde ? new Date(desde) : null,
        valorFechaHasta: hasta ? new Date(hasta) : null,
      }
    };
  }

  getFiltroFechaEnvioPersistido(): FiltroSqp | null {
    if (!this.filtroFechaEnvioPersistido) {
      return null;
    }
    const desde = this.filtroFechaEnvioPersistido.valoresSeleccionados?.valorFechaDesde;
    const hasta = this.filtroFechaEnvioPersistido.valoresSeleccionados?.valorFechaHasta;
    return {
      ...this.filtroFechaEnvioPersistido,
      valoresSeleccionados: {
        ...this.filtroFechaEnvioPersistido.valoresSeleccionados,
        valorFechaDesde: desde ? new Date(desde) : null,
        valorFechaHasta: hasta ? new Date(hasta) : null,
      }
    };
  }

  limpiarFiltroFechaEnvio(): void {
    this.filtroFechaEnvioPersistido = null;
    this.rangoSeleccionado = '';
  }
}
